<template>
  <div class="view-body view-body--module" v-bind:class="{ 'view-body--module--products': view == 'product' }">
    <div class="view-data">
      <div class="button-group button-group--single" v-if="view == 'orders'">
        <button class="button-normal button-normal--media button-normal--searchModule" @click="$emit('upload')" style="display:none">Importuj produkty</button>
      </div>
      <div class="view-data__header view-data__header--module search-header"><h1>Wyszukiwarka</h1></div>
      <div style="position: relative">
        <div class="search-options" >
          <div class="form-group">
            <label class="radio radio--search"><input type="radio" value="products" v-model="type" @change="searching()" /><span class="checkmark"></span> Produkty</label>
            <label class="radio radio--search"><input type="radio" value="images" v-model="type" @change="searching()" /><span class="checkmark"></span> Grafiki</label>
          </div>
          <div class="form-group">
            <input class="form-control form-control-lg search" placeholder="Szukaj" type="text" v-model="phrase" @input="searching()"/>
            <img class ="form-group__icon" src="@/assets/symbols/search.svg">
          </div>
          <div v-if="type == 'images'">
            <div class="search-filters">
              <h2>Filtruj</h2>
              <div class="search-filters__body">
                <div class="form-group">
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.number" @change="searching()"/><span class="checkmark"></span> Nr artykułu</label> -->
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.name" @change="searching()"/><span class="checkmark"></span> Nazwa produktu</label> -->
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.uslugi" @change="searching()"/><span class="checkmark"></span> Usługi</label> -->
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.grafika" @change="searching()"/><span class="checkmark"></span> Grafika</label>
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.prepaid" @change="searching()"/><span class="checkmark"></span> Karty prepaid</label>
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.icon" @change="searching()"/><span class="checkmark"></span> Ikona</label>
                </div>
                <div class="form-group">
                  <label class="checkbox checkbox--search hidden-element" style="opacity: 0; visibility: hidden;"><input type="checkbox"/><span class="checkmark"></span> &nbsp;</label>
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.producer" @change="searching()"/><span class="checkmark"></span> Producent</label> -->
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.logo" @change="searching()"/><span class="checkmark"></span> Logo</label>
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.hero" @change="searching()"/><span class="checkmark"></span> Brand Hero</label>
                </div>
              </div>
            </div>
            <div class="section__header section__header--red" v-if="preselected">Sugerowane Grafiki ({{ preselectedTotalRows }})</div>
            <div class="preselected__images--wrapper" v-if="preselected">
              <vuescroll :ops="scrollOptions">
                <draggable class="preselected__images list-unstyled clearfix" :list="preselectedImages" group="images" @change="getPreselectedImages" @start="activeDragZone('image')" @end="hideDragZone()">
                  <li v-for="image in preselectedImages" :key="image.id" class="small-icon-list-element search__image--item">
                    <img :src="image.href" :alt="image.name" />
                    <span class="info">
                      i
                      <div class="image-info-content">
                        Wielkość w px: {{ image.qualityWidth }}x{{ image.qualityHeight }}<br>
                        Wielkość w cm przy 300 dpi: {{ image.cmWidth }} x {{ image.cmHeight }}
                      </div>
                    </span>
                    <span class="name">
                      <div class="name--zoom" @click="displayImagePopup(image)">
                        <img src="@/assets/symbols/zoom-in.svg" alt="Powiększ zdjęcie" />
                      </div>
                      {{ image.name }}
                    </span>
                    <span class="not-accepted" v-if="image.quality == ''">!</span>
                    <div class="image__quality" v-if="image.quality != null && image.quality.length > 0">
                      <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                      <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                    </div>
                  </li>
                </draggable>
              </vuescroll>
            </div>
            <div class="section__header section__header--red" v-if="!preselected">{{ searchHeader }} ({{ totalRows }})</div>
            <draggable style="position: relative" class="preselected__images list-unstyled clearfix" :list="images" group="images" @start="activeDragZone('image')" @end="hideDragZone()" @change="getXinetImages" v-if="!preselected">
              <li v-for="image in images" :key="image.id" class="small-icon-list-element search__image--item">
                <img :src="image.href" :alt="image.name" />
                <span class="info">
                  i
                  <div class="image-info-content">
                    Wielkość w px: {{ image.qualityWidth }}x{{ image.qualityHeight }}<br>
                    Wielkość w cm przy 300 dpi: {{ image.cmWidth }} x {{ image.cmHeight }}
                  </div>
                </span>
                <span class="name">
                  <div class="name--zoom" @click="displayImagePopup(image)">
                    <img src="@/assets/symbols/zoom-in.svg" alt="Powiększ zdjęcie" />
                  </div>
                  {{ image.name }}
                </span>
                <span class="not-accepted" v-if="image.quality == ''">!</span>
                <div class="image__quality" v-if="image.quality && image.quality.length > 0">
                  <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                  <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                </div>
              </li>
              <loader v-if="loading"/>
            </draggable>
            <b-pagination
              v-if="this.totalRows > 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="4"
              class="search-pagination"
              @change="pageChange">
            </b-pagination>

            <div class="section__header section__header--red" v-if="productId">Ostatnio używane ikony</div>
            <vuescroll :ops="scrollOptions" v-if="productId">
              <draggable style="position: relative" class="icons-list last-used-icons-list list-unstyled list-inline clearfix" :list="icons" group="images" @start="activeDragZone('image')" @end="hideDragZone()" @change="getXinetImages">
                <li v-for="image in icons" class="small-icon-list-element" :key="image.id">
                  <img :src="image.href" :alt="image.name" />
                  <span class="info">
                    i
                    <div class="image-info-content">
                      Wielkość w px: {{ image.qualityWidth }}x{{ image.qualityHeight }}<br>
                      Wielkość w cm przy 300 dpi: {{ image.cmWidth }} x {{ image.cmHeight }}
                    </div>
                  </span>
                  <span class="name">
                    <div class="name--zoom" @click="displayImagePopup(image)">
                      <img src="@/assets/symbols/zoom-in.svg" alt="Powiększ zdjęcie" />
                    </div>
                    {{ image.name }}
                  </span>
                  <span class="not-accepted" v-if="image.quality == ''">!</span>
                  <div class="image__quality" v-if="image.quality && image.quality.length > 0">
                    <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                    <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                  </div>
                </li>
                <loader v-if="loading"/>
              </draggable>
            </vuescroll>
          </div>
        </div>
        <div v-if="type == 'products'">
          <div class="search-filters">
              <h2>Filtruj</h2>
              <div class="search-filters__body">
                <div class="form-group">
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.number" @change="searching()"/><span class="checkmark"></span> Nr artykułu</label>
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.name" @change="searching()"/><span class="checkmark"></span> Nazwa produktu</label>
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.grafika" @change="searching()"/><span class="checkmark"></span> Grafika</label> -->
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.prepaid" @change="searching()"/><span class="checkmark"></span> Karty prepaid</label> -->
                </div>
                <div class="form-group">
                  <!-- <label class="checkbox checkbox--search" style="opacity: 0; visibility: hidden;"><input type="checkbox"/><span class="checkmark"></span> &nbsp;</label> -->
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.producer" @change="searching()"/><span class="checkmark"></span> Producent</label>
                  <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.uslugi" @change="searching()"/><span class="checkmark"></span> Usługi</label>
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.icon" @change="searching()"/><span class="checkmark"></span> Ikona</label> -->
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.logo" @change="searching()"/><span class="checkmark"></span> Logo</label> -->
                  <!-- <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.hero" @change="searching()"/><span class="checkmark"></span> Brand Hero</label> -->
                </div>
              </div>
          </div>
          <div class="section__header section__header--red">Znaleziono ({{totalRows}})</div>
          <draggable class="search-result" style="position: relative" :list="products" group="products" @start="activeDragZone('product')" @end="hideDragZone()" @change="getProducts">
              <div class="search-item" :class="{'selected' : preparedProduct == product.id}" v-for="product in products" :key="product.id" @click="preparedProduct = product.id">
                <div class="search-item__image">
                  <img :src="findMainImage(product)"/>
                </div>
                <div class="search-item__body">
                  <h2>{{product.name}}</h2>
                  <p>Nr art.: {{product.number}}</p>
                </div>
              </div>
              <loader v-if="loading"/>
          </draggable>
          <b-pagination
              v-if="this.totalRows > 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="4"
              class="search-pagination"
              @change="pageChange">
          </b-pagination>
          <div v-if="products && products.length > 0 && view == 'orders'" class="button-group button-group--single">
            <button class="button-normal button-normal--media button-normal--searchModule" @click="$emit('addSingle', {id:preparedProduct}); preparedProduct = ''">Dodaj do zlecenia</button>
        </div>
        </div>
      </div>
    </div>
    <imagePopup v-if="showImagePopup" v-bind:image="imageToEnlarge"></imagePopup>
  </div>
</template>

<script>

import debounce from "lodash.debounce";
import draggable from 'vuedraggable';
import vuescroll from 'vuescroll';
import imagePopup from '@/components/blocks/product/imagePopup';
import loader from '../blocks/loader';

export default {

  name: 'globalSearch',
  props:{
    view: '',
    productNumber: '',
    productType: '',
    productId: '',
    usedGraphics:{
      type: Object,
      default: () => {},
    }
  },
  components:{
    draggable,
    vuescroll,
    imagePopup,
    loader,
  },
  data () {

    return {

      loading: false,

      title: 'Wyszukiwarka',
      searchHeader: 'Sugerowane grafiki',
      showIcons: true,
      products: [],
      images: [],
      icons: [],
      preselectedImages: [],
      preselected: false,
      imageToEnlarge: '',
      showImagePopup: false,
      type: this.view == 'product' ? 'images' : 'products',
      filters: {
        number: false,
        name: false,
        packshot: false,
        grafika: false,
        prepaid: false,
        producer: false,
        icon: false,
        logo: false,
        hero: false,
        uslugi: false,
      },
      preselectedTotalRows: 0,
      preparedProduct: '',
      phrase: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 4,
      iconsPaging: {
        totalRows: 0,
        currentPage: 1,
        perPage: 4,
      },
      offset: 0,

      scrollOptions: {
        rail: {
          background: '#D8D8D8',
          opacity: 1,
          size: '10px',
          gutterOfEnds: '0px',
          border: '2px solid #D8D8D8'
        },
        scrollPanel: {
          scrollingY: true,
          scrollingX: false,
        },
        bar: {
          background: '#939393',
          keepShow: true,
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: '5px',
          size: '6px'
        }
      },

      firstCall: true,

    }

  },
  watch: {
    productNumber: function(){
      this.getPreselectedImages();
    },
    productType: function() {
      this.getIcons();
    }
  },
  methods:{

    activeDragZone(area){

      const zone = document.querySelector('.drop-zone-area');

      if(zone){
        zone.style.visibility = 'visible';
      }

      if(area == 'product'){
        
        const product = document.getElementById('product-area');
        
        if(product)  product.style.visibility = 'visible';

      }

      if(area == 'image'){
        
        const image = document.getElementById('image-area');
        if(image) image.style.visibility = 'visible';

      }

    },

    displayImagePopup(image) {
      this.showImagePopup = true;
      this.imageToEnlarge = image;
    },

    hideDragZone(){

      const zone = document.querySelector('.drop-zone-area');
      const areas = document.querySelectorAll('.custom-drop-area');

      if(zone){
        zone.style.visibility = 'hidden';
      }

      if(areas){

        areas.forEach(element => {
          element.style.visibility = 'hidden';
        });

      }

    },

    getProducts(){

      this.loading = true;

      const token     = localStorage.getItem('auth_token');
      const entries   = Object.entries(this.filters);

      let search = {
        phrase: this.phrase,
        limit: 4,
        offset: this.currentPage,
        filters: {},
      };

      for (const [key, value] of entries) {
        if(value != '') {
          search.filters[key] = 1;
        }
      }

      this.$http.post(`products/ins/orders/searches`, search, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.products = response.data.list
        this.totalRows = response.data.total
        this.loading = false;
      }).catch(error =>{
        this.products = [];
        this.totalRows = 1;
        this.loading = false;
      })

    },

    findMainImage(product){

      let image = product.productImages.find(image => image.isMain == true);

      if(image) return image.href;

    },

    pageChange (page) {
      this.currentPage  = page;
      this.offset       = ((this.currentPage - 1) * this.perPage);
      if ( this.type == 'products' ) {
        this.getProducts();
      }
      if ( this.type == 'images' ) {
        this.getXinetImages();
      }
    },

    getPreselectedImages() {

      // this.loading = true;

      if ( !this.productId ) {
        return;
      }

      const token = localStorage.getItem('auth_token');

      let request = {
        'product' : this.productNumber,
      }

      if ( this.productId ) {
        request.existing = this.productId
      }

      this.isBusy = true;
      this.$http.get(`product-images/images`, {
        params: request,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if ( response.data.list ) {

          if(this.firstCall){

            this.preselectedImages = response.data.list;
            this.preselectedTotalRows  = response.data.total;
            this.firstCall = false;

          }else{

            this.preselectedImages = [];
            let suggestedGraphics = response.data.list;
            let allUsedGraphics = [];


            let keys = Object.keys(this.usedGraphics);
            keys.forEach((item) => {
              this.usedGraphics[item].forEach(image =>{             
                allUsedGraphics.push(image);
              });
            })

            suggestedGraphics.forEach(image =>{

              let found = allUsedGraphics.find(o => o.xinetId == image.xinetId);

              if(!found){
                this.preselectedImages.push(image);
              }

            }),

            this.preselectedTotalRows  = (response.data.total - this.usedGraphics.photos.length) >= 0 ? (response.data.total - this.usedGraphics.photos.length) : response.data.total;
          
          }
        } 

      });
    },

    getXinetImages() {

      this.loading = true;

      const token = localStorage.getItem('auth_token');
      let search = {
        phrase: this.phrase,
        limit: 4,
        offset: this.currentPage,
        filters: {},
      };

      const entries = Object.entries(this.filters);

      for (const [key, value] of entries) {
        if (value) {
          search.filters[key] = true;
        }
      }

      this.$http.post(`product-images/ins/products/searches`, search, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.images       = response.data.list;
        this.totalRows    = response.data.total;
        this.showIcons    = false;
        this.searchHeader = 'Znaleziono';
        this.loading = false;
      }).catch(error => {
        this.loading = false;
      })
    },

    searching: debounce(function() {

      if ( this.phrase.length ) {
        this.preselected = false;
        if ( this.type == 'images' ) {
          this.getXinetImages();
        }
        if ( this.type == 'products' ) {
          this.getProducts();
        }
      }
      
    }, 1000),

    getIcons() {

      this.loading = true;

      const token = localStorage.getItem('auth_token');
      const view  = this.productType;

      let url     = `product-images/recently/all`

      // Zakomentowane - nie ma przypisanych kategorii przy ikonach więc nie pobieramy ikon per kategoria tylko wszystkie
      // let url     = `product-images/${view}/recently/used`;
      // if ( view == 6 ) {
      //   url     = `product-images/recently/all`;
      // }

      this.$http.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.icons      = response.data;
        this.loading = false;
      });
    },

  },
  mounted() {
    if ( this.number != '' ) {
      this.preselected = true;
      this.getPreselectedImages();
    }
    if ( this.productType ) {
      this.getIcons();
    }
  }
};
</script>

<style lang="scss" scoped>

.view-data__header--module{

  & h1{
    font-weight: 700;
    font-size: 14px;
  }
}

.radio, .checkbox {
  padding: 0;
  cursor: pointer;
  margin-right: 25px;

  .checkmark {
    margin: 0 5px 0 0;
  }
}

.checkbox, radio {
  padding: 0;
  color: #000000 !important;
  margin-right: 25px;

  .checkmark {
    margin: 0 5px 0 0;
  }
}

.form-group .search {
  &::placeholder {
    opacity: 0.27;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.12px;
    line-height: 17px;
  }
}

.search-header{
  border-color:#b4b4b4;
}

.button-normal--searchModule{
  font-size: 12px;
  padding: 15px 35px;
  white-space: nowrap;
}

.button-group--single{
  flex-direction: row-reverse;
}

.search-filters{
  display:flex;
  flex-direction: column;
  width:100%;
  position:relative;

  & h2{
    font-size:12px;
  }

  &__body{
    display:flex;
    width:100%;

    @media (max-width: 1500px) {
      display: block !important;
      .hidden-element {
        display: none;
      }
      .form-group {
        margin-bottom: 0;
      }
    }

    & label{
      opacity:1;
      font-weight: 400;
    }

  }

}

.search{
  padding-right: 8%;
}

.checkbox--search{
  margin: 5px 0px;
}

.search-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border:1px #000 solid;
  margin:10px 0px;
  padding: 5px;
  cursor:move;

  &.selected{
    background: rgba(46,204,113,0.14);
    border: 2px solid #2ECC71;
  }

  &__image{
    display:flex;
    position:relative;
    justify-content: center;
    align-items: center;
    width:50px;
    height:50px;
    border:1px red solid;
    background: #E9E9E9;

    & img {
      display:block;
      max-width:100%;
      max-height:100%;
    }
  }

  &__body{
    width:85%;
    padding-left: 15px;
    overflow: hidden;

    & h2{
      font-size: 12px;
    }

    & p{
      font-size: 12px;
    }
  }

}

.preselected__images {

  padding: 5px 18px 5px 8px !important;

  li {

    position: relative;
    float: left;
    width: 48%;
    min-height: 140px;
    margin-right: 4%;
    margin-bottom: 24px;
    border: 1px solid #0E0E0E;

    @media (max-width: 1400px) {
      width: 100%;
      margin-right: 0;
    }

    &:nth-of-type(even) {
      margin-right: 0;
    }

    .name {
      position: absolute;
      bottom: -9px;
      left: -7px;
      color: #000000; 
      font-size: 7px; 
      letter-spacing: 0.07px; 
      line-height: 17px;
      padding: 0px 10px;
      background-color: #ffffff;
      border-radius: 5px;
      min-width: 70%;
    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 90%;
      max-height: 90%;
    }

    .not-accepted {
      position: absolute;
      top: -5px;
      right: -7px;
      width: 14px;
      height: 14px;
      color: #ffffff;
      font-size: 10px;
      line-height: 15px;
      font-weight: 500;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      background-color: #E3000A;
    }

    .info {
      position: absolute;
      z-index: 1090;
      top: -5px;
      left: -7px;
      width: 14px;
      height: 14px;
      color: #ffffff;
      font-size: 10px;
      line-height: 13px;
      font-weight: 500;
      border-radius: 50%;
      text-align: center;

      cursor: pointer;
      background-color: #5CA6FF;

      &:hover {
        .image-info-content {
          position: absolute;
          z-index: 1000;
          display: block;
        }
      }
    }

  }

}

.search__image--item {
  position: relative;
  float: left;
  width: 48%;
  max-width: 200px;
  min-height: 140px;
  margin-right: 4%;
  margin-bottom: 24px;
  border: 1px solid #0E0E0E;

  @media (max-width: 1400px) {
    width: 100%;
    margin-right: 0;
  }

  &:nth-of-type(even) {
    margin-right: 0;
  }

  .name {
    position: absolute;
    bottom: -9px;
    left: -7px;
    color: #000000; 
    font-size: 7px; 
    letter-spacing: 0.07px; 
    line-height: 17px;
    padding: 0px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    min-width: 70%;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    max-height: 90%;
  }

  .not-accepted {
    position: absolute;
    top: -5px;
    right: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 15px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background-color: #E3000A;
  }

  .info {
    position: absolute;
    z-index: 1090;
    top: -5px;
    left: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 13px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;

    cursor: pointer;
    background-color: #5CA6FF;

    &:hover {
      .image-info-content {
        position: absolute;
        z-index: 1000;
        display: block;
      }
    }
  }
}

.search-header {
  margin-bottom: 15px !important;
}

.section__header {
  
  width: 100%;
  color: #4A4A4A;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.12px;
  line-height: 18px;
  padding-bottom: 5px;
  border-bottom: 1px solid #4A4A4A;
  margin-bottom: 15px;

  &--red {
    border-color: #E3000A;
    font-weight: 400;
  }

}

.search-pagination{
  justify-content: center;
}

/* Style do widoku na edycji produktu */
.view-body--module--products {
  height: 100%;
  padding: 10px 10px 10px 15px;
  background-color: rgba(220,220,220,0.5);

  .preselected__images {

    padding: 0 5px;

    li {

      min-height: 100px;

    }

  }

}

.last-used-icons-list {

  padding: 5px 18px 5px 12px;
  max-height: 244px;

}

.preselected__images--wrapper {
  height: 370px;
}

</style>